import React from 'react';
import './NotificationBadge.css';

const NotificationBadge = ({ count }) => {
  if (count <= 0) return null;
  return (
    <span className="notification-badge">
      {count}
    </span>
  );
};

export default NotificationBadge;